var React = require('react');

function DownloadFile (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"}));
}

DownloadFile.defaultProps = {"className":"h-6 w-6","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","strokeWidth":"2"};

module.exports = DownloadFile;

DownloadFile.default = DownloadFile;
